// extracted by mini-css-extract-plugin
export var menuIcon = "_tc-0";
export var menuIconInline = "_tc-1";